import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = BACKEND_URL.endsWith('/api') ? BACKEND_URL : `${BACKEND_URL}/api`;

export const useSSO = (login) => {
  const [isProcessingSSO, setIsProcessingSSO] = useState(false);
  const [ssoError, setSSOError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleSSO = async () => {
      // Vérifier s'il y a un token SSO dans l'URL
      const urlParams = new URLSearchParams(window.location.search);
      const ssoToken = urlParams.get('sso_token');
      
      if (ssoToken && !isProcessingSSO) {
        console.log('SSO token detected, processing...');
        setIsProcessingSSO(true);
        setSSOError(null);
        
        try {
          // Appeler l'endpoint SSO du backend
          const response = await fetch(`${API}/auth/sso?sso_token=${encodeURIComponent(ssoToken)}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          });

          if (response.ok) {
            const data = await response.json();
            
            // Stocker le token et les infos utilisateur
            localStorage.setItem('token', data.access_token);
            
            // Utiliser la fonction login du contexte auth pour mettre à jour l'état global
            console.log('SSO data received:', data);
            if (login && data.user) {
              const loginResult = await login(data.user, data.access_token);
              console.log('SSO login result:', loginResult);
            }
            
            // Nettoyer l'URL (retirer le token SSO)
            const cleanUrl = window.location.origin + window.location.pathname;
            window.history.replaceState({}, document.title, cleanUrl);
            
            console.log('SSO authentication successful');
            
            // Rediriger vers la page appropriée selon le rôle
            const userRole = data.user.role;
            if (userRole === 'rh') {
              navigate('/rh');
            } else if (userRole === 'admin') {
              navigate('/admin');
            } else if (userRole === 'manager') {
              navigate('/manager');
            } else {
              navigate('/');
            }
            
          } else {
            const errorData = await response.json().catch(() => ({}));
            const errorMessage = errorData.detail || 'Erreur lors de l\'authentification SSO';
            console.error('SSO authentication failed:', errorMessage);
            setSSOError(errorMessage);
            
            // Rediriger vers la page de connexion en cas d'erreur
            navigate('/');
          }
          
        } catch (error) {
          console.error('SSO error:', error);
          setSSOError('Erreur de connexion SSO');
          navigate('/');
        } finally {
          setIsProcessingSSO(false);
        }
      }
    };

    handleSSO();
  }, [login, navigate, isProcessingSSO]);

  return {
    isProcessingSSO,
    ssoError
  };
};